import { get, maxBy, findIndex } from 'lodash'
import moment from 'moment'

export default function(data) {
  if (!data) {
    return 0
  }

  const activeAward = maxBy(get(data, 'awards'), award =>
    moment(award.registrationDate)
  )

  return findIndex(get(data, 'awards'), award => award.id === activeAward.id)
}
